const dataAccessMethods = require('../../dataAccessMethods');
const Blockly = require('blockly');
const baseMdcBlockGroup = require('./_BaseMdcBlockGroup');
const setupAddCodeProperties = require('../../helpers/addCodeProperties');
const convertToBoolean = require('../../helpers/convertToBoolean');

function getChartHeights() {
    return [
        // medium needs to be first so it is the default selection
        ['Medium', 'medium'],
        ['Tall', 'tall'],
        ['Short', 'short']
    ];
}

class Graph extends baseMdcBlockGroup {
    addCodeGeneratorCustom(code, blocklyBlock) {
        const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);

        addCodeProperties([
            { key: 'liveReload', handler: val => val.toUpperCase() !== 'FALSE' },
            'namespace',
            'relation',
            'chartHeight',
            'limitResults'
        ]);
        if (blocklyBlock.type === 'HorizontalChart') {
            addCodeProperties([{ key: 'stackValues', handler: convertToBoolean }]);
        }

        return JSON.stringify(code);
    }

    addToBlocksCustom(color, blocklyBlock, hNodeType) {
        // noinspection JSCheckFunctionSignatures // overloaded
        blocklyBlock
            .appendDummyInput()
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField('  Namespace:')
            .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace');

        let blockId = blocklyBlock.id;
        let workspace = blocklyBlock.workspace;
        // noinspection JSCheckFunctionSignatures // overloaded
        const lineOfFields = blocklyBlock
            .appendDummyInput()
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField('  Relation:')
            .appendField(
                new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)),
                'relation'
            )
            .appendField('  Chart Height:')
            .appendField(new Blockly.FieldDropdown(getChartHeights()), 'chartHeight')
            .appendField('  Live Reload:')
            .appendField(new Blockly.FieldCheckbox('false'), 'liveReload')
            .appendField('  Limit Results:')
            .appendField(new Blockly.FieldNumber(21, 0), 'limitResults');

        if (hNodeType === 'HorizontalChart') {
            lineOfFields.appendField('  Stack Values:').appendField(new Blockly.FieldCheckbox(false), 'stackValues');
        }

        blocklyBlock.appendStatementInput('filters').setCheck(['filter']).appendField('Filters:');

        blocklyBlock
            .appendStatementInput('filterControls')
            .setCheck(['actionElement', 'searchPane'])
            .appendField('Filter Controls:');
    }

    customizeToolbox(section) {
        section.contents.forEach(block => {
            block.inputs = {
                filters: {
                    block: {
                        type: 'filter_GroupBy',
                        fields: { propertyName: 'title' },
                        next: {
                            block: {
                                type: 'filter_DateRange'
                            }
                        }
                    }
                }
            };
        });
    }
}

module.exports = Graph;
